
import { useHistory } from 'react-router-dom';
import utils from "utils/index";
import './error.scss';



const Error = props=> {
    const history = useHistory();
    const goBackHome = () => {
        history.push('/')
    }
    return (
        <div className="error-page">
            <img src={utils.imgList.err404Img} alt="err404"/>
            <span className="error-back-btn" onClick={goBackHome}>返回</span>
        </div>
    )
}

export default Error